import { getCategoryLabel, getSkillLabel } from '@/constants/careSkills.ts';

export function formatCareType(careType: string | undefined | null): string {
  if (!careType) return '-';
  return getCategoryLabel(careType);
}

export function formatCareTypes(careTypes: string[] | undefined | null, separator = ', '): string {
  if (!careTypes || careTypes.length === 0) return '-';
  return careTypes.map(formatCareType).join(separator);
}

export function formatSkill(skill: string | undefined | null): string {
  if (!skill) return '-';
  return getSkillLabel(skill);
}

export function formatSkills(skills: string[] | undefined | null, separator = ', '): string {
  if (!skills || skills.length === 0) return '-';
  return skills.map(formatSkill).join(separator);
}
